"use client";

import { useEffect, useRef } from "react";
import { initSentry } from "../config/sentry";
import { setupGlobalErrorHandler } from "../utils/errorHandler";

export function SentryProvider({ children }: { children: React.ReactNode }) {
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      initSentry();
      setupGlobalErrorHandler();
      initialized.current = true;
    }
  }, []);

  return <>{children}</>;
}
